import React from 'react'

const Contact = () => {
  return (
    <div id='contact' className='relative w-full px-[12%] py-4 lg:py-16 scroll-mt-20'>
      {/* 上方：文字 + 地图 */}
      <div className="flex flex-col gap-10 lg:flex-row">
        
        {/* Contact Details 部分 */}
        <section className="lg:w-1/2 space-y-6">  
    <br></br>
          <h3 className='text-left font-bold text-black text-xl xl:text-3xl font-Ovo leading-relaxed'>
            Contact Details
          </h3>            

          <div className="text-left font-Ovo text-md xl:text-xl text-gray-800 space-y-3 leading-relaxed">
            <p>Address: 29 Brandl Street, Eight Mile Plains QLD 4113, Australia</p>
            <p>Email: admin@simoomco.com.au</p>
            <p>Leo: 0425460711</p>
            <p>Eason: 0450226877</p>
          </div>

          <div>
            <h3 className='text-left font-bold text-gray-800 text-xl xl:text-3xl font-Ovo leading-relaxed'>
              Working hours
            </h3>
            <p className="text-left font-Ovo text-md xl:text-xl text-gray-800 space-y-3 leading-relaxed">
              Mon–Fri&nbsp;&nbsp;8:00 – 17:00
            </p>
          </div>
        </section>

         {/* Google Map 部分 */}
         
        <div className="lg:w-1/2 w-full h-[400px] rounded-lg overflow-hidden shadow-lg">  
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3539.0106624250223!2d153.08291177520233!3d-27.57156967626829!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b915a12e18bb9fb%3A0x3c6150cfc753826c!2s29%20Brandl%20St%2C%20Eight%20Mile%20Plains%20QLD%204113%2C%20Australia!5e0!3m2!1sen!2sau!4v1721188403085!5m2!1sen!2sau"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen={false}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  )
}

export default Contact



